<template>
  <div class="section-main__warp reserveRecord-page">
    <ioc-table
      ref="crud"
      v-model="account"
      :data="historyList"
      :option="option"
      :page="page"
      @search-change="getHistory"
      @search-reset="getHistory"
      @size-change="sizeChange"
      @current-change="pageChange"
    >
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click.stop="openRecDetail(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>

    <el-dialog
      :visible.sync="showStepDetails"
      v-dialogDrag
      @close="closeStepDetail"
      title="详情"
    >
      <ioc-table
        style="height: 400px"
        :data="stepHistoryList"
        :option="stepOptionList"
        :page="pageDetails"
        @size-change="sizeChangeDetails"
        @current-change="pageChangeDetails"
      >
        <template slot="图片" slot-scope="scope">
          <img
            :src="scope.row.图片"
            @click="showViewer(scope.row.图片, $event)"
            onerror="this.src='/images/theme/newDark/default.png'"
            style="height: 25px; width: 50px"
          />
        </template>
      </ioc-table>
    </el-dialog>
    <!-- 记录详情 -->
    <reserve-record-details
      ref="record"
      :title="title"
      :textarea="textarea"
      :reportDetails="reportDetails"
      :stepList="stepList"
      :btn="false"
      @handleShowStepDetails="handleShowStepDetails"
    >
    </reserve-record-details>

    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>
<script>
import { formatTimeToStr } from "../filter/dateUtils";
import { Cache } from "$utils";
import { api } from "../api";
import utils from "@src/common/utils";
import tableOption from "../const/table";
import stepOption from "../const/step";
import reserveRecordDetails from "../components/reserveRecordDetails";
export default {
  components: {
    reserveRecordDetails,
  },
  data() {
    return {
      viewerInstance: null,
      viewerPhotos: [],
      url: "",
      paramsData: {},
      total: 0,
      textarea: "",
      reportDetails: [],
      stepList: [],
      activeName: "first",
      title: "预案报告",
      showStepDetails: false,
      showDetails: false,
      account: {},
      historyList: [],
      pageParsm: {},
      stepHistoryList: [],
      option: tableOption(this),
      stepOptionList: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      pageDetails: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      loginAccount: Cache.get("CACHE_USER_INFO").account,
    };
  },
  // computed: {},
  created() {
    this.getHistory();
  },
  methods: {
    showViewer(src, e) {
      this.viewerPhotos = [src];
      this.viewerInstance.show();
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    closeStepDetail() {
      this.stepOptionList = stepOption([]);
      this.stepHistoryList = [];
    },
    handleShowStepDetails(ary, data, url, params, dataAll) {
      this.stepHistoryList = data ? data : [];
      this.stepOptionList = stepOption(ary);
      this.showStepDetails = true;
      // this.pageDetails.total = dataAll.returnObj ? dataAll.returnObj.total : 0;
      // this.paramsData = params;
      // this.url = url;
    },
    getTime(time, type) {
      return formatTimeToStr(time, type);
    },
    getHistory(data) {
      let params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      if (data) {
        this.pageParsm = data;
        (params.type = data.type || ""),
          (params.alarmType = data.alarmType || ""),
          (params.level = data.level || ""),
          (params.status = data.status || ""),
          (params.emergencyPlanName = data.emergencyPlanName || "");
      }
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.getRecordList, params).then((res) => {
        setTimeout(() => {
          loading.close();
        }, 500);

        if (res.success) {
          this.page.total = res.returnObj.total;
          this.historyList = res.returnObj.list;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 查看报告详情
    openRecDetail(row) {
      this.activeName = "first";
      this.$fetch(api.getRecordDetail, {
        emergencyRecordCode: row.emergencyRecordCode,
      }).then((res) => {
        if (res.success) {
          if (!res.returnObj) {
            this.$message.warning("暂无数据，稍后再试");
            return;
          }
          this.stepList = res.returnObj.emergencySubRecordList;
          this.reportDetails = res.returnObj.snapshotFileCodeList;
          this.textarea = res.returnObj.reportDesc;
          this.$refs["record"].showDetails = true;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.getHistory(this.pageParsm);
    },
    pageChange(pageNo) {
      this.page.currentPage = pageNo;
      this.getHistory(this.pageParsm);
    },
    sizeChangeDetails(pageSize) {
      this.$fetch(this.url, {
        pageNum: this.pageDetails.currentPage,
        pageSize: pageSize,
        emergencyProcessID: this.paramsData.emergencyProcessID,
      }).then((res) => {
        this.pageDetails.total = res.returnObj.total;
        this.stepHistoryList = res.returnObj.list;
      });
    },
    pageChangeDetails(pageNo) {
      this.$fetch(this.url, {
        pageNum: pageNo,
        pageSize: this.pageDetails.pageSize,
        emergencyProcessID: this.paramsData.emergencyProcessID,
      }).then((res) => {
        this.pageDetails.total = res.returnObj.total;
        this.stepHistoryList = res.returnObj.list;
      });
    },
  },
};
</script>


